module.exports = __webpack_public_path__ + "img/1.c42d4d4e.jpg";